import maxios from '~/@common/utils/maxios'

// @mathflat/creverse-auth two-phase 함수가 요구하는 fetcher seam.
// maxios 인터셉터가 응답을 언래핑하므로 그대로 반환한다.
// 실패는 호출부가 사유별로 직접 안내하므로 공통 오류 토스트는 끈다.
export const creverseFetcher = <TBody, TResponse>(path: string, body: TBody): Promise<TResponse> =>
  maxios.post<TResponse>(path, body, { preventErrorToast: true })
